import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon, { NAMES } from '@ifit/react-icons';

import { scienceBlue } from '../../theme/colors';
import axisImage from './img/axis@2x.png';
import vueImage from './img/vue@2x.png';

import './index.css';

class WearableButton extends Component {
  renderImage(type) {
    switch (type) {
      case 'axis':
        return axisImage;
      case 'vue':
        return vueImage;
      default:
        return '';
    }
  }

  render() {
    const { onClick, type } = this.props;

    return (
      <div className="wearable-button">
        <button onClick={ onClick }>
          <div className="image">
            <img src={ this.renderImage(type) } alt={ type } />
          </div>
          <div className="arrow">
            <Icon name={ NAMES.ARROW_RIGHT_LONG } color={ scienceBlue } size={ 24 } />
          </div>
        </button>
      </div>
    );
  }
}

WearableButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string.isRequired
};

export default WearableButton;
